import React from "react";

interface SizeProps {
  height?: string;
  width?: string;
  cancelled?: boolean;
}

export default function TableCompletedIcon(props: SizeProps) {
  return (
    <svg
      width="22px"
      height="5px"
      viewBox="0 0 22 5"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Designs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Desktop---Transactions:-Trade-Detail---Note-added"
          transform="translate(-1150.000000, -552.000000)"
        >
          <g id="Group" transform="translate(220.000000, 354.000000)">
            <g id="Trade-2" transform="translate(30.000000, 180.000000)">
              <g id="Status" transform="translate(900.000000, 10.000000)">
                <g id="Group" transform="translate(0.000000, 8.000000)">
                  <line
                    x1="5"
                    y1="2.5"
                    x2="8.5"
                    y2="2.5"
                    id="Path"
                    stroke={props.cancelled ? "#E90C01" : "#0bec9f"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></line>
                  <line
                    x1="13.5"
                    y1="2.5"
                    x2="17"
                    y2="2.5"
                    id="Path"
                    stroke={props.cancelled ? "#E90C01" : "#0bec9f"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></line>
                  <circle
                    id="Oval"
                    fill={props.cancelled ? "#E90C01" : "#0bec9f"}
                    fillRule="nonzero"
                    cx="2.5"
                    cy="2.5"
                    r="2.5"
                  ></circle>
                  <circle
                    id="Oval"
                    fill={props.cancelled ? "#E90C01" : "#0bec9f"}
                    fillRule="nonzero"
                    cx="19.5"
                    cy="2.5"
                    r="2.5"
                  ></circle>
                  <circle
                    id="Oval"
                    fill={props.cancelled ? "#E90C01" : "#0bec9f"}
                    fillRule="nonzero"
                    cx="11"
                    cy="2.5"
                    r="2.5"
                  ></circle>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
